<template>
  <aside class="sidebar" :class="{ activeToggle: store.state.isToggle }">
    <CloseMenuSVG @click="toggleSidebar" class="menu" />

    <div class="profile">
      <div class="avatar">
        <img
          :src="avatarImage"
          :alt="admin.department || 'Default Avatar'"
          class="avatar-img"
        />
      </div>
      <div class="details">
        <span class="name">{{ admin.name }}</span>
        <span class="position">{{ admin.department }}</span>
      </div>
    </div>

    <nav class="nav-categories">
      <ul>
        <li
          v-for="(item, index) in itemCategories"
          :key="index"
          :class="{
            active: $route.path === item.path,
            red: item.name.includes('Red'),
            green: item.name.includes('Green'),
          }"
        >
          <router-link :to="item.path" class="nav-menu" @click="closeSidebar">
            <img :src="require(`@/assets/images/${item.icon}`)" class="icon" />
            {{ item.name }}
          </router-link>
        </li>
      </ul>
    </nav>
  </aside>
</template>

<script>
import CloseMenuSVG from "@/assets/svg/CloseMenuIcon.vue";
import { computed } from "vue";
import { useStore } from "vuex";

export default {
  components: { CloseMenuSVG },
  setup() {
    const store = useStore();

    const admin = computed(() => store.state.adminLogDetails);

    const avatarImage = computed(() => {
      const departmentToImage = {
        "CSU Department": "iwc_csd.png",
        "IT Department": "iwc_it.png",
        "Accounting Department": "iwc_accounting.png",
        "Corp. Services Department": "iwc_admin.png",
        "After-Sales Department": "iwc_marketing.png",
        "Policy Department": "iwc_it.png",
        "SPRU Department": "iwc_spru.png",
        "IWC Management": "iwc_admin.png",
      };

      const filename =
        departmentToImage[admin.value.department] || "iwc_it.png";

      return require(`@/assets/images/${filename}`);
    });

    const itemCategories = [
      {
        name: "IMS Accounts (Red)",
        icon: "ims.png",
        path: "/ims",
      },
      {
        name: "IWC Accounts (Green)",
        icon: "iwc.png",
        path: "/iwc",
      },
    ];

    const toggleSidebar = () => {
      store.state.isToggle = !store.state.isToggle;
    };

    const closeSidebar = () => {
      store.state.isToggle = false;
    };

    return {
      store,
      admin,
      avatarImage,
      itemCategories,
      toggleSidebar,
      closeSidebar,
    };
  },
};
</script>

<style scoped>
.sidebar {
  flex-direction: column;
  min-width: 310px;
  background-color: #f6f7f9;
  height: 100vh;
  overflow: hidden;
  justify-content: space-between;
  padding: 20px 0;
  border: 2px solid #dce0e5;
}

.menu {
  display: none;
}

.profile {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 0 20px;
  margin: 50px 0 60px 0;
}

.avatar-img {
  height: 85px;
  width: 85px;
  border-radius: 50%;
}

.details {
  display: flex;
  flex-direction: column;
}

.name {
  font-size: 16px;
  font-weight: 600;
  color: #111;
}

.position {
  font-size: 13px;
  color: #6f7c8e;
  font-weight: 600;
}

.nav-categories ul {
  list-style: none;
  padding: 0 20px;
}

.nav-categories li {
  margin-bottom: 15px;
  border-radius: 10px;
  overflow: hidden;
}

.nav-categories li a.nav-menu {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 18px;
  font-weight: 600;
  text-decoration: none;
  color: #333;
  background-color: white;
  transition: background-color 0.3s, color 0.3s;
  border: 1px solid #ddd;
  border-radius: 10px;
}

.nav-categories li.red a {
  background-color: white;
  color: #f29900;
}

.nav-categories li.green a {
  background-color: white;
  color: #3f9c35;
}

.nav-categories li.active.red a {
  background-color: #f29900;
  color: white;
}

.nav-categories li.active.green a {
  background-color: #3f9c35;
  color: white;
}

.icon {
  height: 24px;
  width: 24px;
}

@media only screen and (max-width: 440px) {
  .sidebar {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    transform: translateX(-100%);
    transition: transform 0.3s ease-in-out;
    z-index: 999;
  }

  .sidebar.activeToggle {
    transform: translateX(0);
  }

  .menu {
    display: flex;
    justify-content: flex-end;
    padding: 20px;
  }

  .profile {
    flex-direction: column;
    align-items: center;
    margin-bottom: 30px;
  }

  .details {
    text-align: center;
  }
}
</style>
